import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { QuestionListViewComponent } from '../questionlist-view/questionlist-view.component';
import { ChangeStatusQuestionComponent } from '../change-status-question/change-status-question.component';
@Component({
  selector: 'app-question-view',
  templateUrl: './question-view.component.html',
  styleUrls: ['./question-view.component.css']
})
export class QuestionViewComponent implements OnInit {
  tableFilters = '';
  configData: any = {};
  invoiceStatus: any = [];
  invoiceType: any = [];
  screenHeight;
  screenWidth;
  collapsed;
  invoiceCount: number;
  small_device_display = false;
  accountId;
  question_details: any = [];
  id;
  question_array: any = [];
  question_arrays:  any = [];
  constructor(
    private dialog: MatDialog , private commonFilter: CommonfilterService, private route: ActivatedRoute , private commonService: CommonfilterService, private accountService: AccountService
  ) {
    this.commonFilter.getConfigData()
      .subscribe(res => {
        this.configData = res;
      });
   }

    ngOnInit() {
      this.route.parent.params.subscribe(params => {
        this.id = params['id'];
        this.accountService.getQuestions(this.id)
        .subscribe(res => {
        this.question_details = res;
        });
      });
    }
    getview(questions){
      const dialogRef = this.dialog.open(QuestionListViewComponent, {
          width: '1200px',
          height: '450px',
          data: questions 
        });
      
        dialogRef.afterClosed().subscribe(result => {
          
        });
        }
        changeStatus(account,status,qid){
          const dialogRef = this.dialog.open(ChangeStatusQuestionComponent, {
              width: '600px',
              height: '300px',
              data: { 'account': account, 'status': status,'id': qid}
            });
          
            dialogRef.afterClosed().subscribe(result => {
              this.accountService.getQuestions(this.id)
        .subscribe(res => {
        this.question_details = res;
        });
            });
            }
}
